module.exports = __webpack_public_path__ + "img/mspo.ea416100.svg";